export var TaskStatus;
(function (TaskStatus) {
    TaskStatus["idle"] = "idle";
    TaskStatus["loading"] = "loading";
    TaskStatus["success"] = "success";
    TaskStatus["failure"] = "failure";
})(TaskStatus || (TaskStatus = {}));
export default class Task {
    constructor(status, data = null, error = '') {
        this.status = status;
        this.data = data;
        this.error = error;
        this.toString = () => {
            if (this.isFailed) {
                return `${this.status} (${this.error})`;
            }
            else {
                return `${this.status}`;
            }
        };
    }
    static idle() {
        return new Task(TaskStatus.idle);
    }
    static loading() {
        return new Task(TaskStatus.loading);
    }
    static success(data) {
        return new Task(TaskStatus.success, data);
    }
    static failure(error) {
        return new Task(TaskStatus.failure, null, error);
    }
    get isFinished() {
        return this.status === TaskStatus.success || this.status === TaskStatus.failure;
    }
    get isSuccessful() {
        return this.status === TaskStatus.success;
    }
    get isFailed() {
        return this.status === TaskStatus.failure;
    }
    get isLoading() {
        return this.status === TaskStatus.loading;
    }
    get hasData() {
        return this.data != null;
    }
    get resetIfFinished() {
        return this.isFinished ? Task.idle() : this;
    }
}
